import React, { FunctionComponent, ReactElement, useState, useEffect, useContext } from 'react';
import localforage from 'localforage';
import _ from 'lodash';
import { TuneFilters, TuneModel } from '../../../shared/types';
import { tuneApi } from '../../../api/tuneApi';
import TuneTable from './TuneTable/TuneTable';
import { setUsersNames } from '../../../utils/getAuthorizedUserNames';
import { UserContext } from '../../../context/UserContext';
import { hasCMSAccess } from '../../../utils/auth';

const Tune: FunctionComponent<any> = (props: any): ReactElement => {
  const [tuneList, setTuneList] = useState<TuneModel[]>([]);
  const [filteredTuneList, setFilteredTuneList] = useState<TuneModel[]>([]);
  const [openDeleteTuneDialog, setOpenDeleteTuneDialog] = useState<boolean>(false);
  const [tunesToDelete, setTunesToDelete] = useState<TuneModel[]>([]);
  const [tuneIdsToDelete, setTuneIdsToDelete] = useState<string[]>([]);

  const user = useContext(UserContext).user;

  const loadTunes = async () => {
    let response: TuneModel[] = await tuneApi.getTunes();
    response = response.map((item) => {
      item.isEditMode = false;
      item.isCreateMode = false;
      item.authorizedUsers = item.authorizedUsers || [];
      item.authorizedRoles = item.authorizedRoles || [];
      return item;
    });

    response = await setUsersNames(response);
    setTuneList(response);
    setFilteredTuneList(response);
    localforage.setItem('tunes', response);
  };

  const filterTunes = (term: string) => {
    let newList: TuneModel[] = _.cloneDeep(tuneList);
    switch (term) {
      case TuneFilters.onlyMyTunes:
        newList = newList.filter((tune) => tune.userId === user.id);
        break;
      case TuneFilters.onlyGlobal:
        newList = newList.filter((tune) => tune.global);
        break;

      default:
        newList = tuneList;
        break;
    }

    setFilteredTuneList(newList);
  }

  const deleteHandler = (tuneIds: string[]) => {
    setOpenDeleteTuneDialog(true);
    const tunes = tuneList.filter((tune) => tuneIds.includes(tune.id));
    setTunesToDelete(tunes);
    setTuneIdsToDelete(tuneIds);
  };

  const deleteTune = async () => {
    const promises = [];
    for (let i = 0; i < tuneIdsToDelete.length; i++) {
      promises.push(tuneApi.deleteTune(tuneIdsToDelete[i]));
    }
    await Promise.all(promises);
    setOpenDeleteTuneDialog(false);
    loadTunes();
  };

  const handleClose = () => {
    setOpenDeleteTuneDialog(false);
  };

  useEffect(() => {
    if (hasCMSAccess(user)) {
      loadTunes();
    }
  }, [user]);

  const tuneTableProps = {
    filteredTuneList,
    openDeleteTuneDialog,
    tunesToDelete,
    deleteHandler,
    deleteTune,
    handleClose,
    filterTunes,
  };

  return (
    <div data-testid='tune-container'>
      <TuneTable {...tuneTableProps} />
    </div>
  )
};

export default Tune;
